export const normalizeUsPhone = (value: string): string => {
  const rawPhone = value.trim();
  if (!rawPhone) {
    return '';
  }

  if (/^[2-9]\d{9}$/.test(rawPhone)) {
    return `+1${rawPhone}`;
  }

  throw new Error('Enter a 10-digit U.S. phone number starting with area code, such as 4795551234.');
};

export const formatStoredUsPhoneForInput = (value?: string | null): string => {
  const rawPhone = value?.trim() || '';
  if (!rawPhone) {
    return '';
  }

  const digits = rawPhone.replace(/\D/g, '');
  if (rawPhone.startsWith('+1') && digits.length === 11) {
    return digits.slice(1);
  }
  if (/^[2-9]\d{9}$/.test(rawPhone)) {
    return rawPhone;
  }

  return rawPhone;
};

export const phoneInputDigitsOnly = (value: string): string => (
  value.replace(/\D/g, '').slice(0, 10)
);
